<template>
  <v-card
    flat
    :height="$vuetify.breakpoint.mdAndDown ? 'calc(100vh - 140px)' : ''"
  >
    <v-card-subtitle class="mt-1 text-subtitle-1"
      >Velg tidsseriene som skal eksporteres i tabellen under ved å huke av i
      sjekkboksene.</v-card-subtitle
    >
    <v-tabs color="primary" v-model="activeTab">
      <v-tab
        class="ml-2"
        ripple
        color="primary"
        @keyup.space="activeTab = 0"
        v-show="showStationsFromOtherActors"
      >
        <v-icon class="pr-2">mdi-table</v-icon>NVE tidsserier
      </v-tab>
      <v-tab
        ripple
        @keyup.space="activeTab = 1"
        v-if="showStationsFromOtherActors"
      >
        <v-icon class="pr-2">mdi-table</v-icon>Andre tidsserier
      </v-tab>
      <v-spacer></v-spacer>
      <the-column-selector class="pt-2" />

      <v-tab-item :eager="true">
        <data-table
          v-if="show"
          :clear-selected-time-series-on-startup="false"
          :headers="selectedColumns"
          @selection-changed="updateSelectedTimeSeries"
          :all-headers="vheaders"
          :data-url="mainLayerUrl"
          :query-expression="queryExpression"
          :select-time-series="selectedTimeSeries"
          :show-info-on-click="false"
          sort-by="stasjonNavn"
          :table-height="
            $vuetify.breakpoint.mdAndDown
              ? 'calc(100vh - 340px)'
              : 'calc(70vh - 200px)'
          "
          class="tidsserie-table"
        ></data-table>
      </v-tab-item>

      <v-tab-item :eager="true" v-if="showStationsFromOtherActors">
        <data-table
          v-if="show"
          :clear-selected-time-series-on-startup="false"
          :headers="selectedColumnsOtherActors"
          @selection-changed="updateSelectedTimeSeriesOtherActors"
          :all-headers="otherTimeseriesHeaders"
          :data-url="otherActorsLayerUrl"
          :select-time-series="selectedTimeSeriesOtherActors"
          :show-info-on-click="false"
          :query-expression="queryExpressionStationsFromOtherActors"
          sort-by="STASJONSNAVN"
          :table-height="
            $vuetify.breakpoint.mdAndDown
              ? 'calc(100vh - 340px)'
              : 'calc(70vh - 200px)'
          "
          class="tidsserie-table"
        ></data-table>
      </v-tab-item>
    </v-tabs>

    <v-card-actions>
      <v-spacer />
      <v-btn depressed text @click="cancel">
        Avbryt
      </v-btn>

      <v-btn
        depressed
        :disabled="
          timeSeriesMarkedForExport.length <= 0 &&
            timeSeriesOtherActorsMarkedForExport.length <= 0
        "
        @click="emitStepCompleted"
      >
        Neste
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DataTable from "./DataTable.vue";
import TheColumnSelector from "../../components/Layout/TheColumnSelector.vue";
import { mapState } from "vuex";

export default {
  name: "ExportDataStep1",
  components: {
    DataTable,
    TheColumnSelector,
  },
  data: () => {
    return {
      activeTab: null,
      timeSeriesMarkedForExport: [],
      timeSeriesOtherActorsMarkedForExport: [],
    };
  },
  props: {
    show: Boolean,
  },
  computed: {
    ...mapState([
      "chartDateRange",
      "tabell",
      "selectedTimeSeries",
      "selectedTimeSeriesOtherActors",
      "selectedColumns",
      "selectedColumnsOtherActors",
      "showStationsFromOtherActors",
      "queryExpression",
      "queryExpressionStationsFromOtherActors",
      "activeTableTab",
      "vheaders",
      "otherTimeseriesHeaders",
    ]),
    mainLayerUrl: function() {
      return (
        process.env.VUE_APP_BASE_URL +
        "/" +
        process.env.VUE_APP_BASE_URL_LAYER_INDEX
      );
    },
    otherActorsLayerUrl: function() {
      return (
        process.env.VUE_APP_SECOND_LAYER_URL +
        process.env.VUE_APP_SECOND_URL_LAYER_INDEX
      );
    },
  },
  methods: {
    cancel: function() {
      this.$emit("cancel");
    },
    updateSelectedTimeSeries: function(newVal) {
      this.timeSeriesMarkedForExport = newVal;
    },
    updateSelectedTimeSeriesOtherActors: function(newVal) {
      this.timeSeriesOtherActorsMarkedForExport = newVal;
    },
    emitStepCompleted: function() {
      this.$emit("step-completed", {
        timeSeriesMarkedForExport: this.timeSeriesMarkedForExport,
        timeSeriesOtherActorsMarkedForExport: this
          .timeSeriesOtherActorsMarkedForExport,
      });
    },
  },
};
</script>
